import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=36ed6214&"
import script from "./Chip.vue?vue&type=script&lang=js&"
export * from "./Chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ed6214')) {
      api.createRecord('36ed6214', component.options)
    } else {
      api.reload('36ed6214', component.options)
    }
    module.hot.accept("./Chip.vue?vue&type=template&id=36ed6214&", function () {
      api.rerender('36ed6214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Chip.vue"
export default component.exports